import httpClient from './httpClient'

export default {
  async getHosts() {
    let ret = await httpClient.get('hosts/uploader')
    return ret
  },
}
